<div class="port-charges-tab">
  <!-- Header Section -->
  <div class="d-flex justify-content-between align-items-start mb-4">
    <div>
      <h5 class="mb-1"><i class="bi bi-list-ul me-2"></i>Origin Charges</h5>
      <p class="text-muted small mb-0">Port Charges</p>
      <p class="text-muted small mb-0">Manage port charges for agent-port combinations (both origin and destination)</p>
    </div>
    <button class="btn btn-primary" (click)="openAddPortChargeModal()">
      <i class="bi bi-plus-circle me-2"></i>Add Port Charge
    </button>
  </div>

  <!-- Filters Section -->
  <div class="filters-section mb-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="mb-0"><i class="bi bi-funnel me-2"></i>Filters</h6>
      <button class="btn btn-link btn-sm text-decoration-none" (click)="toggleAdvancedFilters()">
        Advanced Filters
        <i class="bi" [ngClass]="showAdvancedFilters ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </button>
    </div>

    <div class="row g-3">
      <!-- Search Bar -->
      <div class="col-md-3">
        <div class="input-group">
          <span class="input-group-text bg-white">
            <i class="bi bi-search"></i>
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="Search agents, ports..."
            [(ngModel)]="searchTerm"
          />
        </div>
      </div>

      <!-- Agent Filter -->
      <div class="col-md-3">
        <select class="form-select" [(ngModel)]="selectedAgent">
          <option *ngFor="let agent of agents" [value]="agent">{{ agent }}</option>
        </select>
      </div>

      <!-- Port Filter -->
      <div class="col-md-3">
        <select class="form-select" [(ngModel)]="selectedPort">
          <option *ngFor="let port of ports" [value]="port">{{ port }}</option>
        </select>
      </div>

      <!-- Type Filter -->
      <div class="col-md-3">
        <select class="form-select" [(ngModel)]="selectedType">
          <option *ngFor="let type of types" [value]="type">{{ type }}</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Results Summary -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <p class="text-muted small mb-0">
      Showing {{ filteredPortCharges.length }} of {{ portCharges.length }} port charges
    </p>
    <div class="d-flex align-items-center gap-2">
      <span class="text-muted small">Sort by:</span>
      <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="sortBy">
        <option value="Valid From">Valid From</option>
        <option value="Agent">Agent</option>
        <option value="Port">Port</option>
      </select>
    </div>
  </div>

  <!-- Port Charges Table -->
  <div class="table-responsive">
    <table class="table table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th>Agent</th>
          <th>Port (with Code)</th>
          <th>Charge Type</th>
          <th>Validity</th>
          <th>Currency</th>
          <th>Status</th>
          <th>Carrier-Specific Charges</th>
          <th style="width: 120px;">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let charge of filteredPortCharges">
          <!-- Agent -->
          <td>
            <div class="fw-medium">{{ charge.agent }}</div>
          </td>

          <!-- Port (with Code) -->
          <td>
            <div>{{ charge.port }}</div>
            <div class="text-muted small">({{ charge.portCode }})</div>
          </td>

          <!-- Charge Type -->
          <td>
            <span class="badge bg-primary">{{ charge.chargeType }}</span>
          </td>

          <!-- Validity -->
          <td>
            <div>{{ formatValidity(charge.validFrom, charge.validTo) }}</div>
          </td>

          <!-- Currency -->
          <td>
            <span class="text-muted">{{ charge.currency }}</span>
          </td>

          <!-- Status -->
          <td>
            <span
              class="badge"
              [ngClass]="{
                'bg-success': charge.status === 'Active',
                'bg-secondary': charge.status === 'Inactive',
                'bg-danger': charge.status === 'Expired'
              }"
            >
              {{ charge.status }}
            </span>
          </td>

          <!-- Carrier-Specific Charges -->
          <td>
            <button
              class="btn btn-sm btn-outline-primary"
              (click)="manageCarrierCharges(charge)"
              *ngIf="charge.hasCarrierCharges"
            >
              <i class="bi bi-currency-dollar me-1"></i>Manage
            </button>
            <span class="text-muted small" *ngIf="!charge.hasCarrierCharges">—</span>
          </td>

          <!-- Actions -->
          <td>
            <div class="btn-group btn-group-sm" role="group">
              <button class="btn btn-link p-1 text-primary" (click)="viewCharge(charge)" title="View">
                <i class="bi bi-eye"></i>
              </button>
              <button class="btn btn-link p-1 text-primary" (click)="editCharge(charge)" title="Edit">
                <i class="bi bi-pencil"></i>
              </button>
              <button class="btn btn-link p-1 text-danger" (click)="deleteCharge(charge)" title="Delete">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </td>
        </tr>

        <!-- Empty State -->
        <tr *ngIf="filteredPortCharges.length === 0">
          <td colspan="8" class="text-center py-5">
            <i class="bi bi-inbox text-muted" style="font-size: 3rem;"></i>
            <p class="text-muted mt-3">No port charges found</p>
            <button class="btn btn-primary btn-sm" (click)="openAddPortChargeModal()">
              <i class="bi bi-plus-circle me-2"></i>Add First Port Charge
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Add Port Charge Modal -->
<app-add-port-charge-modal
  [show]="showAddPortChargeModal"
  (close)="closeAddPortChargeModal()"
  (save)="savePortCharge($event)"
></app-add-port-charge-modal>

<!-- Carrier-Specific Charges Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showCarrierChargesModal"
     style="z-index: 1070 !important; background-color: rgba(0, 0, 0, 0.7) !important;"
     (click)="closeCarrierChargesModal()"></div>
<div class="modal fade show d-block" *ngIf="showCarrierChargesModal"
     style="z-index: 1071 !important; position: fixed !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Header with Icon and Title -->
      <div class="modal-header border-0 pb-0">
        <div class="d-flex align-items-center gap-3">
          <div class="icon-wrapper" style="background-color: #e7f3ff; padding: 12px; border-radius: 12px;">
            <i class="bi bi-truck" style="font-size: 1.5rem; color: #0d6efd;"></i>
          </div>
          <div>
            <h5 class="modal-title mb-0">Carrier-Specific Charges</h5>
            <p class="text-muted small mb-0" *ngIf="selectedPortCharge">
              {{ selectedPortCharge.agent }} • {{ selectedPortCharge.port }}
            </p>
          </div>
        </div>
        <button type="button" class="btn-close" (click)="closeCarrierChargesModal()"></button>
      </div>

      <!-- Info Box -->
      <div class="modal-body pt-3">
        <div class="alert alert-info d-flex align-items-start" role="alert" style="background-color: #e7f3ff; border-color: #b6d4fe;">
          <i class="bi bi-info-circle me-2 mt-1"></i>
          <div>
            Configure carrier-specific charges for FCL shipments. Only charges with amounts greater than 0 will be saved.
          </div>
        </div>

        <!-- Select Carriers Section -->
        <div class="card border-0 shadow-sm mb-3">
          <div class="card-body">
            <h6 class="card-title mb-3">
              <i class="bi bi-plus-circle me-2"></i>Select Carriers
            </h6>

            <!-- Add Carrier Dropdown -->
            <div class="mb-3">
              <select class="form-select" [(ngModel)]="selectedCarrierToAdd" (change)="addCarrierToSelection()">
                <option value="">+ Add Carrier</option>
                <option *ngFor="let carrier of availableCarriersForSelection" [value]="carrier.id">
                  {{ carrier.name }}
                </option>
              </select>
            </div>

            <!-- Selected Carriers List or Empty State -->
            <div *ngIf="selectedCarriersForCharges.length === 0" class="text-center py-5">
              <i class="bi bi-truck" style="font-size: 3rem; color: #dee2e6;"></i>
              <p class="text-muted mt-3 mb-1"><strong>No Carriers Selected</strong></p>
              <p class="text-muted small">Choose one or more carriers to configure their specific charges for this route.</p>
            </div>

            <!-- Selected Carriers Table -->
            <div *ngIf="selectedCarriersForCharges.length > 0" class="table-responsive">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>Carrier</th>
                    <th class="text-end">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let carrier of selectedCarriersForCharges">
                    <td>
                      <i class="bi bi-truck me-2"></i>{{ carrier.name }}
                    </td>
                    <td class="text-end">
                      <button class="btn btn-sm btn-link text-danger p-0" (click)="removeCarrierFromSelection(carrier.id)">
                        <i class="bi bi-x-circle"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeCarrierChargesModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveCarrierCharges()">
          Save Carrier Charges
        </button>
      </div>
    </div>
  </div>
</div>
